 
import React from "react";
 
const DashboardView = React.lazy(() =>import("../Pages/Home/Home"));
const AppointmentsView = React.lazy(() =>import("../Pages/Appointments/Appointments"));
const AddAppointmentsView = React.lazy(() =>import("../Pages/Appointments/AddAppointments"));
const EditAppointmentsView = React.lazy(() =>import("../Pages/Appointments/EditAppointments"));
const HistoryView = React.lazy(() =>import("../Pages/Appointments/History/HistoryView"));
const TestLogView = React.lazy(() =>import("../Pages/Appointments/History/Log/TestLog"));
const MedicineLogView = React.lazy(() =>import("../Pages/Appointments/History/Log/MedicineLog"));
const AddLabTestView = React.lazy(() =>import("../Pages/Appointments/Add/AddLabTest"));
const AddMedicineView = React.lazy(() =>import("../Pages/Appointments/Add/AddMedicine"));
const AppointmentRequestView = React.lazy(() =>import("../Pages/Appointments/Request/AppointmentRequest.jsx"));
const EditAppointmentRequestView = React.lazy(() =>import("../Pages/Appointments/Request/EditAppointmentRequest.jsx"));
const AnalyticsView = React.lazy(()=>import ("../Pages/Analytics/AnalyticsDashboard.jsx"));
const SlotSetupView = React.lazy(()=>import("../Pages/SlotSetup/SlotSetup.jsx"));
const AddSlotView = React.lazy(()=>import("../Pages/SlotSetup/AddSlot/AddSlot.jsx"));
const EditSlotView = React.lazy(()=> import("../Pages/SlotSetup/EditSlot/EditSlot.jsx") )
const ProfileView = React.lazy(() =>import("../Pages/Profile/Profile"));

const PatientView = React.lazy(() =>import("../Pages/Patient/Patients.jsx"));
const AddPatientAppointmentsView = React.lazy(() =>import("../Pages/Patient/AddPatientAppoinment.jsx"));
const PatientEditAppointmentsView = React.lazy(() =>import("../Pages/Patient/PatientEditAppoinments.jsx"));
const PatientHistoryView = React.lazy(() =>import("../Pages/Patient/History/PatientHistoryView.jsx"));
const PatientTestLogView = React.lazy(() =>import("../Pages/Patient/History/Log/PatientTestLog.jsx"));
const PatientMedicineLogView = React.lazy(() =>import("../Pages/Patient/History/Log/PatientMedicineLog.jsx"));
const PatientAddLabTestView = React.lazy(() =>import("../Pages/Patient/Add/PatientAddLabTest.jsx"));
const PatientAddMedicineView = React.lazy(() =>import("../Pages/Patient/Add/PatientAddMedicine.jsx"));
const PatientAppointmentRequestView = React.lazy(() =>import("../Pages/Patient/PatientRequest/PatientAppoinmentRequest.jsx"));
const PatientEditAppointmentRequestView = React.lazy(() =>import("../Pages/Patient/PatientRequest/PatientEditAppoinmentRequest.jsx"));




 
 
const AdminRoutes = [
    { path: "/", name: "Home", Element: DashboardView },
    { path: "/appointments",name: "Appointments", Element: AppointmentsView},
    { path: "/appointments/addappointments",name: "Add Appointments", Element: AddAppointmentsView},
    { path: "/appointments/updateappointments/:id",name: "Update Appointments", Element: EditAppointmentsView},
    { path: "/appointments/history",name: "History", Element: HistoryView},
    { path: "/appointments/history/testlog",name: "Test Log", Element: TestLogView},
    { path: "/appointments/history/medicinelog",name: "Medicine Log", Element: MedicineLogView},
    { path: "/appointments/addtest",name: "Add Test", Element: AddLabTestView},
    { path: "/appointments/addmedicine",name: "Add Medicine", Element: AddMedicineView},
    { path: "/appointments/request",name: "Request", Element: AppointmentRequestView},
    { path: "/appointments/editrequest",name: "Edit Request", Element: EditAppointmentRequestView},
    { path: "/analytics", name:"Analytics", Element:AnalyticsView},
    { path: "/slotsetup",name: "SlotSetup", Element: SlotSetupView},
    { path: "/slotsetup/addslot",name: "AddSlotSetup", Element: AddSlotView},
    {path: "/slotsetup/editslot", name: "EditSlotSetup", Element:EditSlotView},
    { path: "/profile",name: "Profile", Element: ProfileView},

    { path: "/patients",name: "patients", Element:PatientView},
    { path: "/patients/addpatient",name: "AddAppointment", Element: AddPatientAppointmentsView},
    { path: "/patients/updatepatientappoinments",name: "EditAppointment", Element: PatientEditAppointmentsView},
    { path: "/patients/patienthistory",name: "History", Element: PatientHistoryView},
    { path: "/patients/history/patienttestlog",name: "TestLog", Element: PatientTestLogView},
    { path: "/patients/history/patientmedicinelog",name: "MedicineLog", Element: PatientMedicineLogView},
    { path: "/patients/patientaddtest",name: "AddTest", Element: PatientAddLabTestView},
    { path: "/patients/patientaddmedicine",name: "AddMedicine", Element: PatientAddMedicineView},
    { path: "/patients/patientrequest",name: "Request", Element: PatientAppointmentRequestView},
    { path: "/patients/patienteditrequest",name: "EditRequest", Element: PatientEditAppointmentRequestView},
  
   
 
  ]
 
export default AdminRoutes;
 
 